<template>
  <div>

    <div class="content" v-if="!induListShow">

      <div class="search-box"
        style="display: flex;width: 1000px;margin: 0 auto;border-radius: 25px;box-shadow: 0px 5px 5px 0 rgba(0, 0, 0, 0.1);margin-bottom: 40px;">
        <div style="flex: 1;">
          <div style="background: #fff;height: 36px;padding: 5px 25px;border: 2px solid #EA3928;border-top-left-radius: 25px;border-bottom-left-radius: 25px;display: flex;align-items: center;">
            <div style="width: 40px;text-align: center;margin-top: 4px;"><img src="../../static/img/search.svg"></div>
            <input type="text" placeholder="请在此输入股票名称或代码" v-model="inputText" @input="search"
              @focus="searchResultShow = true"
              style="width: calc(100% - 40px);background: #fff;border: none;outline: none;height: 36px;font-size: 18px;">
          </div>
        </div>
        <div style="width: 130px;background-color: rgb(234, 57, 40);border-radius: 25px;margin-left: -25px;display: flex;justify-content: center;align-items: center;cursor: pointer;">
          <span style="color: #fff;font-size: 18px;">搜索</span>
        </div>
      </div>

      <div class="search-result-box" v-if="searchResultShow"
        style="width: 905px;background-color: #fff;border-radius: 8px;position: absolute;top: 122px;left: calc(50% - 485px);z-index: 1000;box-shadow: 0px 5px 5px 0 rgba(0, 0, 0, 0.1);">
        <div v-if="searchListData == null || searchListData.length <= 0" style="padding: 7px;">
          <div v-if="searchData == null" style="text-align: center;color: #393939;height: 30px;line-height: 30px;">
            加载中，请输入名称或代码</div>
          <div v-else style="text-align: center;color: #393939;height: 30px;line-height: 30px;">抱歉，暂未搜索到相关的搜索结果</div>
        </div>
        <div v-else style="padding: 7px;">
          <table cellspacing="0" style="width: 100%;text-align: center;">
            <thead>
              <tr style="height: 40px;line-height: 40px;">
                <th style="width: 33.3%">股票名称</th>
                <th style="width: 33.3%">股票代码</th>
                <th style="width: 33.3%">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr style="height: 40px;line-height: 40px;" v-for="(item, index) in searchListData">
                <td>{{ item.comName }}</td>
                <td>
                  <div style="display: flex;justify-content: center;align-items: center;">
                    <div>{{ item.comCode }}</div>
                  </div>
                </td>
                <td>
                  <div style="display: flex;justify-content: center;">
                    <div style="color: #3a8ee6;cursor: pointer;margin-right: 30px;" @click="searchToResearch(item)">查看
                    </div>
                    <div style="color: #3a8ee6;cursor: pointer;" @click="addOption(item.comCode)">添加自选</div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="search-back" v-if="searchResultShow" @click="searchResultShow = false"
        style="position: absolute;top: 50px;left: 0;width: 100%;height: 100%;z-index: 10;">
      </div>

      <div class="hot-box" style="display: flex;margin-bottom: 40px;">
        <div class="hot-sectors" style="flex: 1;">
          <div style="font-size: 18px;font-weight: 600;">热门板块</div>
          <div>
            <div class="hot-box-body-border">
              <div class="hot-box-body">
                <div
                  style="color: #fff;width: 24%;height: 134px;border-bottom: 3px solid rgb(255, 255, 255);border-right: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                  @click="showHotIndu(increaseData[0])">
                  <span>{{ increaseData[0] == null ? '-' : increaseData[0].industryName }}</span>
                  <span>{{ increaseData[0] == null ? '-' : increaseData[0].growthRate + '%' }}</span>
                </div>
                <div
                  style="color: #fff;width: 24%; height: 105px; border-right: 3px solid rgb(255, 255, 255); display: flex; align-items: center; flex-direction: column; justify-content: center;cursor: pointer;"
                  @click="showHotIndu(increaseData[1])">
                  <span>{{ increaseData[1] == null ? '-' : increaseData[1].industryName }}</span>
                  <span>{{ increaseData[1] == null ? '-' : increaseData[1].growthRate + '%' }}</span>
                </div>

                <div
                  style="color: #fff;width: 22%;height: 79px;border-bottom: 3px solid rgb(255, 255, 255);border-right: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                  @click="showHotIndu(increaseData[2])">
                  <span>{{ increaseData[2] == null ? '-' : increaseData[2].industryName }}</span>
                  <span>{{ increaseData[2] == null ? '-' : increaseData[2].growthRate + '%' }}</span>
                </div>
                <div
                  style="color: #fff;width: 22%;height: 79px;border-bottom: 3px solid rgb(255, 255, 255);border-right: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                  @click="showHotIndu(increaseData[3])">
                  <span>{{ increaseData[3] == null ? '-' : increaseData[3].industryName }}</span>
                  <span>{{ increaseData[3] == null ? '-' : increaseData[3].growthRate + '%' }}</span>
                </div>
                <div
                  style="color: #fff;width: 22%;height: 79px;border-right: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                  @click="showHotIndu(increaseData[4])">
                  <span>{{ increaseData[4] == null ? '-' : increaseData[4].industryName }}</span>
                  <span>{{ increaseData[4] == null ? '-' : increaseData[4].growthRate + '%' }}</span>
                </div>

                <div style="display: flex;width: calc(100% - 15px);">
                  <div
                    style="color: #fff;width: 18%;height: 169px;border-bottom: 3px solid rgb(255, 255, 255);border-right: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                    @click="showHotIndu(increaseData[5])">
                    <span>{{ increaseData[5] == null ? '-' : increaseData[5].industryName }}</span>
                    <span>{{ increaseData[5] == null ? '-' : increaseData[5].growthRate + '%' }}</span>
                  </div>
                  <div
                    style="color: #fff;width: 18%;height: 169px;border-bottom: 3px solid rgb(255, 255, 255);border-right: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                    @click="showHotIndu(increaseData[6])">
                    <span>{{ increaseData[6] == null ? '-' : increaseData[6].industryName }}</span>
                    <span>{{ increaseData[6] == null ? '-' : increaseData[6].growthRate + '%' }}</span>
                  </div>
                  <div
                    style="color: #fff;width: 18%;height: 169px;border-bottom: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                    @click="showHotIndu(increaseData[7])">
                    <span>{{ increaseData[7] == null ? '-' : increaseData[7].industryName }}</span>
                    <span>{{ increaseData[7] == null ? '-' : increaseData[7].growthRate + '%' }}</span>
                  </div>
                </div>

                <div style="display: flex;width: calc(100% - 15px);">
                  <div
                    style="color: #fff;width: 27%;height: 70px;border-right: 3px solid rgb(255, 255, 255);display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                    @click="showHotIndu(increaseData[8])">
                    <span>{{ increaseData[8] == null ? '-' : increaseData[8].industryName }}</span>
                    <span>{{ increaseData[8] == null ? '-' : increaseData[8].growthRate + '%' }}</span>
                  </div>
                  <div
                    style="color: #fff;width: 27%;height: 70px;display: flex;align-items: center;flex-direction: column;justify-content: center;cursor: pointer;"
                    @click="showHotIndu(increaseData[9])">
                    <span>{{ increaseData[9] == null ? '-' : increaseData[9].industryName }}</span>
                    <span>{{ increaseData[9] == null ? '-' : increaseData[9].growthRate + '%' }}</span>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <div class="hot-company">
          <div style="display: flex;">
            <div style="position: relative;width: 26px;">
              <svg xmlns="http://www.w3.org/2000/svg" width="19" height="22" viewBox="0 0 19 22" fill="none" style="
                  position: absolute;
                  left: 0;
                  z-index: 10;
              ">
                <path
                  d="M4.91223 22C4.98934 21.9998 5.06588 21.9866 5.13867 21.9612C5.66439 21.7743 6.17127 21.5382 6.65257 21.256C8.55602 20.1777 10.0587 18.5115 10.9355 16.5073L10.9743 16.4167C11.1284 16.6805 11.2583 16.9576 11.3625 17.2448C11.8323 18.451 11.8621 19.7842 11.4466 21.0101C11.4106 21.1214 11.4055 21.2403 11.4317 21.3542C11.4579 21.4681 11.5145 21.5728 11.5954 21.6571C11.677 21.7425 11.7804 21.804 11.8945 21.8347C12.0085 21.8655 12.1289 21.8645 12.2424 21.8318C14.3764 21.1844 16.1659 19.716 17.2175 17.7494C17.92 16.4261 18.2562 14.9391 18.1913 13.4422C18.1265 11.9454 17.663 10.493 16.8488 9.23535C16.7258 9.04126 16.59 8.85364 16.4541 8.67896C16.3456 8.55506 16.194 8.4772 16.0301 8.46125C15.8662 8.4453 15.7023 8.49245 15.572 8.5931C15.4416 8.69374 15.3546 8.84031 15.3285 9.00292C15.3025 9.16554 15.3395 9.33195 15.4319 9.46826C15.5484 9.62353 15.6583 9.7788 15.7619 9.94054C16.4522 11.0046 16.8455 12.2339 16.9013 13.501C16.957 14.7682 16.6731 16.0272 16.0789 17.1478C15.3818 18.4507 14.2965 19.5044 12.9734 20.1626C13.0126 19.8558 13.032 19.5468 13.0317 19.2375C13.0332 18.3986 12.8774 17.5669 12.5723 16.7855C12.2836 15.9869 11.8443 15.2511 11.2784 14.6181C11.1989 14.5293 11.0964 14.4642 10.9822 14.4299C10.8681 14.3957 10.7467 14.3936 10.6314 14.424C10.5188 14.4513 10.4155 14.5083 10.3324 14.5891C10.2493 14.6699 10.1895 14.7715 10.1591 14.8834C10.0507 15.26 9.91887 15.6295 9.76448 15.9897C8.99529 17.7395 7.68141 19.1941 6.01854 20.1367C5.69658 20.3288 5.35895 20.4933 5.00927 20.6284C3.30615 19.4157 2.08694 17.6396 1.56741 15.6144C1.39513 14.9093 1.30824 14.186 1.30862 13.46C1.29876 11.8356 1.74723 10.2412 2.60256 8.86011C2.73166 9.11884 2.87642 9.36947 3.03602 9.61059C3.71795 10.687 4.64456 11.587 5.74035 12.2373C5.95384 12.3602 6.16087 12.4702 6.38731 12.5737C6.5063 12.6291 6.63934 12.6471 6.76876 12.6251C6.89819 12.6032 7.01787 12.5424 7.11192 12.4508C7.19927 12.3539 7.25528 12.2328 7.2726 12.1035C7.28992 11.9742 7.26773 11.8427 7.20896 11.7262C6.76265 10.6594 6.54236 9.51168 6.56199 8.35547C6.56331 7.96195 6.58708 7.56882 6.63316 7.17799C6.74384 6.395 6.96153 5.63091 7.28013 4.90714V4.83598L7.31894 4.76481C7.82607 3.6479 8.57261 2.65618 9.50569 1.85993C9.64797 2.71801 9.92069 3.54928 10.3144 4.32487C10.3986 4.46484 10.5327 4.56777 10.6897 4.61299C10.8466 4.65821 11.0149 4.64238 11.1607 4.56867C11.3065 4.49496 11.419 4.36883 11.4756 4.21561C11.5322 4.06238 11.5288 3.89341 11.466 3.7426C10.9886 2.78026 10.7301 1.72416 10.7091 0.6501C10.7096 0.533044 10.6784 0.418027 10.6188 0.317305C10.5591 0.216584 10.4733 0.133932 10.3703 0.0781583C10.2674 0.0223842 10.1513 -0.00442254 10.0344 0.000594643C9.91741 0.00561183 9.80401 0.0422649 9.70625 0.106648C8.16729 1.1042 6.9425 2.51742 6.17381 4.18254C6.1281 4.25557 6.09119 4.33375 6.06383 4.41545C5.70064 5.24023 5.45247 6.11099 5.32629 7.00331C5.28135 7.45257 5.26191 7.90402 5.26806 8.35547C5.26876 9.06454 5.34467 9.77153 5.4945 10.4646C4.96828 10.0179 4.51243 9.49448 4.14234 8.91187C3.8007 8.42482 3.52649 7.89381 3.32716 7.33327C3.28957 7.22727 3.225 7.1329 3.13981 7.05948C3.05463 6.98605 2.95177 6.93609 2.84139 6.91454C2.73101 6.89298 2.61692 6.90058 2.51037 6.93657C2.40382 6.97256 2.30849 7.0357 2.23379 7.11977C0.790436 8.91288 0.00294304 11.1453 0.00175095 13.4471C0.00169754 14.2777 0.101618 15.1053 0.299355 15.912C0.923487 18.364 2.44193 20.494 4.5564 21.8836C4.66094 21.9566 4.78473 21.9971 4.91223 22Z"
                  fill="#6B400D"></path>
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none" style="
                  position: absolute;
                  left: 2px;
                  bottom: -1px;
                  z-index: 5;
              ">
                <path
                  d="M2.46071 4.92709C2.53376 4.83787 2.62932 4.76979 2.73751 4.7299C2.8457 4.69001 2.96259 4.67977 3.07607 4.70022C3.18955 4.72067 3.2955 4.77108 3.38296 4.84623C3.47041 4.92138 3.5362 5.01854 3.5735 5.12765C3.76179 5.65976 4.04209 6.15466 4.40161 6.58979C4.37561 6.34914 4.36265 6.10725 4.3628 5.86519C4.36569 5.56459 4.38513 5.26437 4.42102 4.96591C4.50683 4.36577 4.67444 3.78021 4.91919 3.22557C4.93888 3.16165 4.96717 3.10071 5.00329 3.04442C5.51898 1.92705 6.34265 0.979941 7.37766 0.314216C7.47601 0.257433 7.58758 0.227539 7.70115 0.227539C7.81471 0.227539 7.92628 0.257433 8.02463 0.314216C8.12698 0.368702 8.2128 0.44969 8.27312 0.54871C8.33344 0.647729 8.36605 0.76114 8.36752 0.877077C8.3761 1.55144 8.53758 2.21507 8.83981 2.81798C9.20885 3.55619 9.78127 4.1735 10.4896 4.59714C11.2195 5.02807 11.8466 5.61318 12.327 6.3116C12.9272 7.23367 13.2464 8.31035 13.2456 9.41057C13.2574 10.3434 13.035 11.2644 12.5987 12.089C12.1219 12.9671 11.4238 13.7053 10.5737 14.2305C10.4667 14.3028 10.3405 14.3414 10.2114 14.3414C10.0822 14.3414 9.95606 14.3028 9.84907 14.2305C9.74518 14.1545 9.66629 14.0493 9.6225 13.9283C9.57871 13.8073 9.572 13.676 9.60323 13.5512C9.70177 13.1269 9.75169 12.6928 9.75203 12.2572C9.754 11.5753 9.62667 10.8991 9.37679 10.2646C9.2726 9.9774 9.14267 9.70023 8.98861 9.43645L8.94979 9.52702C8.07303 11.5313 6.57032 13.1975 4.66687 14.2758C4.52874 14.3589 4.3862 14.4345 4.23987 14.5022L4.16871 14.541C4.05734 14.5946 3.93296 14.6151 3.81028 14.6002C3.6876 14.5853 3.57176 14.5356 3.47645 14.4569C2.34138 13.5387 1.53163 12.2799 1.16678 10.8662C1.0304 10.3136 0.958755 9.74689 0.953281 9.17766C0.955489 7.63021 1.48747 6.13017 2.46071 4.92709Z"
                  fill="#FFC824"></path>
              </svg>
            </div>
            <span style="color: #EA3928;">热门公司</span>
          </div>
          <div style="display: flex;flex-direction: column;flex-wrap: wrap;height: 220px;">

            <div style="height: 30px;font-size: 16px;margin-top: 14px;" v-for="(item, index) in hotCompany" :key="index">
              <span v-if="index < 4"
                style="width: 35px;display: inline-block;text-align: center;font-size: 20px;color: #FFC495;">{{ index + 1
                }}</span>
              <span v-else style="width: 35px;display: inline-block;text-align: center;font-size: 20px;color: #747679;">{{
                index + 1 }}</span>
              <span @click="searchToResearch(item)" style="cursor: pointer;">{{ item.comName }}</span>
            </div>

          </div>
        </div>

      </div>

      <div class="stock-ranking">

        

        <div class="box-item-tab">
          <div class="box-item-title">
            <div style="font-size: 18px;font-weight: 600;">股票排行</div>
            <div class="box-item-title-icon"></div>
          </div>
          <template v-for="(item, index) in tabPane2">
            <div class="box-item-tab-pane tab-pane-selected" :key="'s' + index" v-if="index == activeTab2"
              @click="handleSelect(2, index)">{{ item.name }}
            </div>
            <div class="box-item-tab-pane" :key="index" v-else @click="handleSelect(2, index)">{{ item.name }}
            </div>
          </template>
        </div>

        <div class="box-item-pane" style="min-height: 150px;">

          <table cellspacing="0" v-if="activeTab2 == 0">
            <thead>
              <tr>
                <th>公司简称</th>
                <th>股票代码</th>
                <th>最新价</th>
                <th>涨幅</th>
                <!-- <th>所属行业</th> -->
              </tr>
            </thead>
            <tbody>
              <template v-if="tableDataRise == null || tableDataRise == undefined || tableDataRise.length == 0">
                <tr style="height: 350px;">
                  <td colspan="99">暂无数据</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(item, index) in tableDataRise" :key="index" @click="rankingToResearch(item)">
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td style="color: #EA3928;">{{ item.trade }}</td>
                  <td style="color: #EA3928;">{{ toRate(item.changepercent) }}</td>
                  <!-- <td>{{ item.symbol }}</td> -->
                </tr>
              </template>
            </tbody>
          </table>

          <table cellspacing="0" v-if="activeTab2 == 1">
            <thead>
              <tr>
                <th>公司简称</th>
                <th>股票代码</th>
                <th>最新价</th>
                <th>跌幅</th>
                <!-- <th>所属行业</th> -->
              </tr>
            </thead>
            <tbody>
              <template v-if="tableDataFall == null || tableDataFall == undefined || tableDataFall.length == 0">
                <tr style="height: 350px;">
                  <td colspan="99">暂无数据</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(item, index) in tableDataFall" :key="index" @click="rankingToResearch(item)">
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td style="color: #07AB4B;">{{ item.trade }}</td>
                  <td style="color: #07AB4B;">{{ toRate(item.changepercent) }}</td>
                  <!-- <td>{{ item.symbol }}</td> -->
                </tr>
              </template>
            </tbody>
          </table>

          <table cellspacing="0" v-if="activeTab2 == 2">
            <thead>
              <tr>
                <th>公司简称</th>
                <th>股票代码</th>
                <th>最新价</th>
                <th>成交额</th>
                <th>成交量</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="tableDataDeal == null || tableDataDeal == undefined || tableDataDeal.length == 0">
                <tr style="height: 350px;">
                  <td colspan="99">暂无数据</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(item, index) in tableDataDeal" :key="index" @click="rankingToResearch(item)">
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td style="color: #EA3928;">{{ toMoney(item.trade) }}</td>
                  <td style="color: #EA3928;">{{ toMoney(item.amount) }}</td>
                  <td>{{ item.volume }}</td>
                </tr>
              </template>
            </tbody>
          </table>

          <table cellspacing="0" v-if="activeTab2 == 3">
            <thead>
              <tr>
                <th>公司简称</th>
                <th>股票代码</th>
                <th>最新价</th>
                <th>换手率</th>
                <th>成交量</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="tableDataChange == null || tableDataChange == undefined || tableDataChange.length == 0">
                <tr style="height: 350px;">
                  <td colspan="99">暂无数据</td>
                </tr>
              </template>
              <template v-else>
                <tr v-for="(item, index) in tableDataChange" :key="index" @click="rankingToResearch(item)">
                  <td>{{ item.name }}</td>
                  <td>{{ item.code }}</td>
                  <td style="color: #EA3928;">{{ toMoney(item.trade) }}</td>
                  <td style="color: #EA3928;">{{ toRate(item.turnoverratio) }}</td>
                  <td>{{ item.volume }}</td>
                </tr>
              </template>
            </tbody>
          </table>

          <!--            <div class="view-more">-->
          <!--                <div>查看更多</div>-->
          <!--                <i class="el-icon-arrow-down"></i>-->
          <!--            </div>-->

        </div>
      </div>
    </div>

    <div class="content" v-if="induListShow">
      <div @click="back()"
        style="height: 30px;width: 60px;display: flex;align-items: center;font-weight: 600;cursor: pointer;">
        <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
          <path
            d="M8.45728 2.66904C8.60418 2.52192 8.71467 2.35638 8.78794 2.17243C8.86161 1.9887 8.89844 1.79936 8.89844 1.60507C8.89844 1.41056 8.86161 1.21875 8.78794 1.02961C8.71428 0.840481 8.6042 0.672482 8.45728 0.525345C8.16262 0.231105 7.81085 0.0839844 7.40073 0.0839844C6.99145 0.0839844 6.63885 0.231105 6.34502 0.525345L0.497413 6.42033C0.350088 6.54656 0.24498 6.70671 0.182055 6.90122C0.118738 7.09554 0.0926619 7.29791 0.103433 7.50792C0.113354 7.71815 0.160955 7.92549 0.244964 8.13034C0.328972 8.33561 0.444426 8.51151 0.591766 8.65841L6.34502 14.4588C6.63926 14.7638 6.99145 14.9161 7.40073 14.9161C7.81087 14.9161 8.16263 14.7638 8.45728 14.4588C8.60418 14.3119 8.71467 14.1464 8.78794 13.9626C8.86161 13.7789 8.89844 13.5893 8.89844 13.3952C8.89844 13.2007 8.86161 13.0087 8.78794 12.82C8.71467 12.6309 8.6042 12.4625 8.45728 12.3151L3.69684 7.49217L8.45728 2.66904Z"
            fill="#EA3928" />
        </svg>
        <span style="margin-left: 10px;">返回</span>
      </div>
      <div class="box-item-pane">
        <table cellspacing="0">
          <thead>
            <tr>
              <th>股票名称</th>
              <th>股票代码</th>
              <th>所属行业</th>
              <th>涨幅</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="induList == null || induList == undefined || induList.length == 0">
              <tr style="height: 350px;">
                <td colspan="99">暂无数据</td>
              </tr>
            </template>
            <template v-else>
              <tr v-for="(item, index) in induList" :key="index" @click="induToResearch(item)">
                <td>{{ item.companyName }}</td>
                <td>{{ item.companyCode }}</td>
                <td>{{ item.industryCode }}</td>
                <td>{{ item.growthRate + '%' }}</td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</template>
      
<script>
import { linkName, sendRequestCompany2, sendRequestIndustry } from '../../static/js/util';

export default {
  data() {
    return {
      isLogin: false,
      increaseData: [],
      days: 1,//1,5,30
      induListShow: false,
      induList: [],
      hotCompany: [
        { comCode: '002445', comName: '中南文化' },
        { comCode: '603153', comName: '上海建科' },
        { comCode: '002235', comName: '安妮股份' },
        { comCode: '603598', comName: '引力传媒' },
        { comCode: '002893', comName: '京能热力' },
        { comCode: '600725', comName: '云维股份' },
        { comCode: '000705', comName: '浙江震元' },
        { comCode: '600712', comName: '南宁百货' },
        { comCode: '603230', comName: '内蒙新华' },
        { comCode: '603660', comName: '苏州科达' },
      ],

      tabPane2: [
        { name: '涨幅榜' },
        { name: '跌幅榜' },
        { name: '成交额' },
        { name: '换手率' },
      ],
      activeTab2: 0,
      tableDataRise: [],
      tableDataFall: [],
      tableDataDeal: [],
      tableDataChange: [],

      inputText: '',
      searchResultShow: false,
      searchData: null,
      searchListData: null
    };
  },
  mounted() {
    // var logState = sessionStorage.getItem('isLogin');
    // if (logState != null && logState == 'true') {
    //   this.isLogin = true;
    // }

    //热股
    this.getHotList();
    //股票代码和名字
    this.getSearchData();
    //热门板块
    this.getData(1, 0);
    //涨幅榜
    this.getData(2, 0);
  },
  methods: {
    //切换tab
    handleSelect(sign, index) {
      if (sign == 2) {
        this.activeTab2 = index;
        this.getData(sign, index);
      }
    },
    //金额单位转万元
    toMoney(num) {
      if (num == '') {
        return '-';
      }
      var minus = 1;
      if (num < 0) {
        minus = -1;
        num = num * -1;
      }
      if (num < 10000) {
        return minus * num;
      } else if (num < 100000000) {
        var temp = num / 10000;
        return minus * temp.toFixed(2) + ' 万';
      } else {
        var temp = num / 100000000;
        return minus * temp.toFixed(2) + ' 亿';
      }
    },
    toRate(num) {
      num = parseFloat(num)
      if (isNaN(num)) {
        return '-';
      } else {
        return num.toFixed(2) + '%';
      }
    },
    //取热门股
    getHotList() {
      let url = 'company/tongHotCom'
      sendRequestIndustry(url, 'get', null, (res) => {
        // console.log(res)
        if(res.data.code==0) {
          this.hotCompany = res.data.data;
          this.hotCompany.splice(10);
        }
      }, (err) => {
        console.log(err)
      });
    },
    getSearchData() {
      let url = '/company/comList'
      sendRequestCompany2(url, 'get', null, response => {
        // console.log(response.data)
        this.searchData = response.data;
        if (this.inputText !== '') {
          this.search();
        }
      }, error => {
        console.log(error);
      })
    },
    search() {
      var text = this.inputText;
      if (text !== '' && text.length > 0) {
        let isNumber = !isNaN(parseFloat(text)) && isFinite(text);
        let ret = isNumber == true ? this.QueryCode(this.searchData, text) : this.QueryName(this.searchData, text)
        if (ret != null) {
          this.searchListData = ret;
        }
      } else {
        this.searchListData = null;
      }
    },
    QueryName(list, keyWord) {
      var reg = new RegExp(keyWord);
      var arr = [];
      if (list == null) {
        return arr;
      }
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].comName)) {
          arr.push(list[i]);
          if (arr.length > 10) {
            break;
          }
        }
      }
      return arr;
    },
    QueryCode(list, keyWord) {
      var reg = new RegExp(keyWord);
      var arr = [];
      if (list == null) {
        return arr;
      }
      for (var i = 0; i < list.length; i++) {
        if (reg.test(list[i].comCode)) {
          arr.push(list[i]);
          if (arr.length > 10) {
            break;
          }
        }
      }
      return arr;
    },
    getData(sign, tab) {
      if (sign == 1) {
        //热门板块
        sendRequestIndustry('/research/industry?days=1',
          'get',
          null,
          res => {
            // console.log(res)
            if (res.data.flag) {
              this.increaseData = res.data.data;
            } else {
              this.increaseData = [];
            }
          }, err => {
            console.log(err);
          })

      } else if (sign == 2) {
        const loading = this.$loading({
            target: $('.box-item-pane')[0],
            lock: true,
            text: '加载中',
            spinner: 'el-icon-loading',
            background: 'rgba(255, 255, 255, 0.8)'
        });
        if (tab == 0) {
          //涨幅榜
          sendRequestIndustry('/sina/topStockList' +
            '?page=' + 1 +
            '&num=' + 10 +
            '&topType=' + 'changepercenttop',
            'get',
            null,
            res => {
              loading.close();
              // console.log(res)
              if (res.data.code == 0) {
                this.tableDataRise = res.data.data.records;
              } else {
                this.tableDataRise = [];
              }
            }, err => {
              loading.close();
              console.log(err);
            })

        } else if (tab == 1) {
          //跌幅榜
          sendRequestIndustry('/sina/topStockList' +
            '?page=' + 1 +
            '&num=' + 10 +
            '&topType=' + 'changepercentdown',
            'get',
            null,
            res => {
              loading.close();
              // console.log(res)
              if (res.data.code == 0) {
                this.tableDataFall = res.data.data.records;
              } else {
                this.tableDataFall = [];
              }
            }, err => {
              loading.close();
              console.log(err);
            })

        } else if (tab == 2) {
          //成交额
          sendRequestIndustry('/sina/topStockList' +
            '?page=' + 1 +
            '&num=' + 10 +
            '&topType=' + 'amount',
            'get',
            null,
            res => {
              loading.close();
              // console.log(res)
              if (res.data.code == 0) {
                this.tableDataDeal = res.data.data.records;
              } else {
                this.tableDataDeal = [];
              }
            }, err => {
              loading.close();
              console.log(err);
            })

        } else if (tab == 3) {
          //换手率
          sendRequestIndustry('/sina/topStockList' +
            '?page=' + 1 +
            '&num=' + 10 +
            '&topType=' + 'turnoverratio',
            'get',
            null,
            res => {
              loading.close();
              // console.log(res)
              if (res.data.code == 0) {
                this.tableDataChange = res.data.data.records;
              } else {
                this.tableDataChange = [];
              }
            }, err => {
              loading.close();
              console.log(err);
            })
        }
      }
    },
    rankingToResearch(item) {
      if (sessionStorage.getItem('isLogin')=='false') {
        this.$confirm('请先登录, 是否跳转登录界面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$router.push({ name: 'login' });
        }).catch(() => { });
        return;
      }
      // window.location.href = '/beawanHome/companyResearch/research?comCode=' + item.code + '&name=' + item.name
      // linkName(this, 'business', { comCode: item.code, comName: item.name });
      linkName(this, 'companyReport', { comCode: item.code, comName: item.name });
    },
    searchToResearch(item) {
      if (sessionStorage.getItem('isLogin')=='false') {
        this.$confirm('请先登录, 是否跳转登录界面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$router.push({ name: 'login' });
        }).catch(() => { });
        return;
      }
      // window.location.href = '/beawanHome/companyResearch/research?comCode=' + item.comCode + '&name=' + item.comName
      // linkName(this, 'business', { comCode: item.comCode, comName: item.comName });
      linkName(this, 'companyReport', { comCode: item.comCode, comName: item.comName });
    },
    induToResearch(item) {
      if (sessionStorage.getItem('isLogin')=='false') {
        this.$confirm('请先登录, 是否跳转登录界面?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info'
        }).then(() => {
          this.$router.push({ name: 'login' });
        }).catch(() => { });
        return;
      }
      // window.location.href = '/beawanHome/companyResearch/research?comCode=' + item.companyCode + '&name=' + item.companyName
      // linkName(this, 'business', { comCode: item.companyCode, comName: item.companyName });
      linkName(this, 'companyReport', { comCode: item.companyCode, comName: item.companyName });
    },
    addOption(comCode) {
      let url = '/company/addSelfCom?comCode=' + comCode;
      sendRequestCompany2(url, 'get', null, response => {
        // console.log(response.data)
        if (response.data.code == 0) {
          this.$message({
            message: '添加成功',
            type: 'success'
          });
        } else if (response.data.code == 1) {
          this.$message.error(response.data.msg);
        } else {
          this.$message.error("添加失败");
        }
      }, error => {
        console.log(error);
      })
    },
    showHotIndu(increaseData) {
      if (increaseData == undefined || increaseData == null) {
        return;
      }
      let url = '/research/industryCompany?industryCode=' + increaseData.industryCode + '&days=' + this.days;
      sendRequestIndustry(url, 'get', null, response => {
        // console.log(response.data);
        if (response.data.flag) {
          this.induList = response.data.data;
          for (var i = 0; i < this.induList.length; i++) {
            this.induList[i].industryCode = increaseData.industryName;
          }
          this.induListShow = true;
        }
      }, error => {
        console.log(error);
      })
    },
    back() {
      this.induListShow = false;
    }
  }
};
</script>
      
<style scoped>
.content {
  flex-direction: column;
}


.box-item-tab,
.box-item-title {
  display: flex;
  align-items: center;
}

.box-item-tab {
  /* border-bottom: 1px solid rgba(0, 0, 0, 0.2); */
  margin: 15px 10px 0 10px;
}

.box-item-title-icon {
  height: 30px;
  width: 4px;
  margin-left: 30px;
  margin-right: 10px;
  border-radius: 5px;
  background-color: #ff8423;
}

.box-item-title-text {
  font-size: 17px;
  line-height: 30px;
  margin-right: 50px;
}

.box-item-tab-pane {
  padding: 0 15px;
  color: #4c4c4d;
  height: 30px;
  line-height: 30px;
  margin: 4px 0;
  /* border-left: 1px solid rgba(0, 0, 0, 0);
  border-right: 1px solid rgba(0, 0, 0, 0); */
  cursor: pointer;
}

.tab-pane-selected {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  /* border-top: 1px solid rgba(0, 0, 0, 0.2);
  border-left: 1px solid rgba(0, 0, 0, 0.2);
  border-right: 1px solid rgba(0, 0, 0, 0.2);
  border-bottom: 1px solid #f4f5f7;
  margin-bottom: -1px; */
  background-color: #FBF2F6;
  color: #EA3928;
}

.box-item-pane {
  padding: 7px;
  border-radius: 6px;
  border: 1px solid rgba(234, 57, 40, 0.40);
  margin-bottom: 7px;
  background-color: #fff;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.09);
}

.box-item-title-note /deep/ p {
  margin: 0;
}

.box-item-pane>table {
  width: 100%;
  text-align: center;
  border-collapse: collapse;
  /* border-left: 1px solid #9f9f9f;
            border-right: 1px solid #9f9f9f;
            border-bottom: 1px solid #9f9f9f; */
}

.box-item-pane>table>tbody>tr,
.box-item-pane>table>thead>tr {
  /* border-top: 1px solid #9f9f9f; */
  height: 35px;
}

.box-item-pane>table>tbody>tr:hover {
  background-color: #d8d8d8 !important;
}

/* .box-item-pane>table>tbody>tr:nth-child(2n+1) {
  background-color: #EAF1FF;
} */

.box-item-pane>table>thead>tr>th {
  font-weight: 500;
  font-size: 18px;
}

.view-more {
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.60);
}

.hot-box-body-border {
  margin: 10px 30px;
  padding: 3px;
  border: 1px solid rgba(234, 57, 40, 0.40);
  border-radius: 15px;
}
.hot-box-body {
  height: 243px;
  background-color: #F95858;
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-content: flex-start;
}
.hot-company {
  width: 290px;
  /* height: fit-content; */
  padding: 15px;
  border-radius: 8px;
  border: 1px solid rgba(234, 57, 40, 0.40);
  background: linear-gradient(180deg, #FF9D1E -36.68%, #FFF 21.21%);
}
</style>